import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "主页",
    },
  },
  {
    path: "/worker",
    name: "worker",
    component: () => import("../views/Worker.vue"),
    meta: {
      title: "维修工",
    },
  },
  {
    path: "/fw",
    name: "follow",
    component: () => import("../views/FollowView.vue"),
    meta: {
      title: "关注页",
    },
  },
  {
    path: "/qrresult",
    name: "qrresult",
    component: () => import("../views/QrresultView.vue"),
    meta: {
      title: "查询结果",
      keepAlive: true
    },
  },
  {
    path: "/recommendation",
    name: "recommendation",
    component: () => import("../views/Recommendation.vue"),
    meta: {
      title: "推荐官"
    },
  },
  {
    path: "/qrview",
    name: "qrview",
    component: () => import("../views/Qrview.vue"),
    meta: {
      title: "防伪查询"
    }
  },
  {
    path: "/qrinfo",
    name: "qrinfo",
    component: () => import("../views/Qrinfo.vue"),
    meta: {
      title: "防伪查询结果"
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
